export const GraphBarColorSet = {
  blue: {
    backgroundColor: '#86C7F5',
    borderColor: '#4f81bd',
    pointBackgroundColor: '#86C7F5',
    pointBorderColor: '#4f81bd',
    pointHoverBackgroundColor: '#86C7F5',
    pointHoverBorderColor: '#4f81bd'
  },
  red: {
    backgroundColor: '#ff7d98',
    borderColor: '#ef5350',
    pointBackgroundColor: '#ff7d98',
    pointBorderColor: '#ef5350',
    pointHoverBackgroundColor: '#ff7d98',
    pointHoverBorderColor: '#ef5350'
  },
  colors: function () {
    return [
      this.blue,
      this.red
    ]
  }
}

export const GraphLineColorSet = {
  blue: {
    backgroundColor: '#81d4fa',
    borderColor: '#81d4fa',
    pointBackgroundColor: '#29b6f6',
    pointBorderColor: '#29b6f6',
    pointHoverBackgroundColor: '#29b6f6',
    pointHoverBorderColor: '#29b6f6'
  },
  green: {
    backgroundColor: '#a5d6a7',
    borderColor: '#a5d6a7',
    pointBackgroundColor: '#66bb6a',
    pointBorderColor: '#66bb6a',
    pointHoverBackgroundColor: '#66bb6a',
    pointHoverBorderColor: '#66bb6a'
  },
  yellow: {
    backgroundColor: '#fff59d',
    borderColor: '#fff59d',
    pointBackgroundColor: '#ffee58',
    pointBorderColor: '#ffee58',
    pointHoverBackgroundColor: '#ffee58',
    pointHoverBorderColor: '#ffee58'
  },
  orange: {
    backgroundColor: '#ffab91',
    borderColor: '#ffab91',
    pointBackgroundColor: '#ff7043',
    pointBorderColor: '#ff7043',
    pointHoverBackgroundColor: '#ff7043',
    pointHoverBorderColor: '#ff7043'
  },
  grey: {
    backgroundColor: '#b0bec5',
    borderColor: '#b0bec5',
    pointBackgroundColor: '#78909c',
    pointBorderColor: '#78909c',
    pointHoverBackgroundColor: '#78909c',
    pointHoverBorderColor: '#78909c'
  },
  red: {
    backgroundColor: '#ef9a9a',
    borderColor: '#ef9a9a',
    pointBackgroundColor: '#ef5350',
    pointBorderColor: '#ef5350',
    pointHoverBackgroundColor: '#ef5350',
    pointHoverBorderColor: '#ef5350'
  },
  purple: {
    backgroundColor: '#b39ddb',
    borderColor: '#b39ddb',
    pointBackgroundColor: '#7e57c2',
    pointBorderColor: '#7e57c2',
    pointHoverBackgroundColor: '#7e57c2',
    pointHoverBorderColor: '#7e57c2'
  },
  blue_l: {
    backgroundColor: '#b3e5fc',
    borderColor: '#b3e5fc',
    pointBackgroundColor: '#4fc3f7',
    pointBorderColor: '#4fc3f7',
    pointHoverBackgroundColor: '#4fc3f7',
    pointHoverBorderColor: '#4fc3f7'
  },
  green_l: {
    backgroundColor: '#c8e6c9',
    borderColor: '#c8e6c9',
    pointBackgroundColor: '#81c784',
    pointBorderColor: '#81c784',
    pointHoverBackgroundColor: '#81c784',
    pointHoverBorderColor: '#81c784'
  },
  yellow_l: {
    backgroundColor: '#fff9c4',
    borderColor: '#fff9c4',
    pointBackgroundColor: '#fff176',
    pointBorderColor: '#fff176',
    pointHoverBackgroundColor: '#fff176',
    pointHoverBorderColor: '#fff176'
  },
  orange_l: {
    backgroundColor: '#ffccbc',
    borderColor: '#ffccbc',
    pointBackgroundColor: '#ff8a65',
    pointBorderColor: '#ff8a65',
    pointHoverBackgroundColor: '#ff8a65',
    pointHoverBorderColor: '#ff8a65'
  },
  grey_l: {
    backgroundColor: '#cfd8dc',
    borderColor: '#cfd8dc',
    pointBackgroundColor: '#90a4ae',
    pointBorderColor: '#90a4ae',
    pointHoverBackgroundColor: '#90a4ae',
    pointHoverBorderColor: '#90a4ae'
  },
  red_l: {
    backgroundColor: '#ffcdd2',
    borderColor: '#ffcdd2',
    pointBackgroundColor: '#e57373',
    pointBorderColor: '#e57373',
    pointHoverBackgroundColor: '#e57373',
    pointHoverBorderColor: '#e57373'
  },
  purple_l: {
    backgroundColor: '#d1c4e9',
    borderColor: '#d1c4e9',
    pointBackgroundColor: '#9575cd',
    pointBorderColor: '#9575cd',
    pointHoverBackgroundColor: '#9575cd',
    pointHoverBorderColor: '#9575cd'
  },

  colors: () => {
    return Object.keys(GraphLineColorSet).map(key => {
      if (key !== 'colors') {
        return GraphLineColorSet[key]
      }
    })
  }
}

export const GraphStackBarColorSet = {
  blue: {
    backgroundColor: '#29b6f6',
    borderColor: '#4fc3f7',
    pointBackgroundColor: '#29b6f6',
    pointBorderColor: '#4fc3f7',
    pointHoverBackgroundColor: '#29b6f6',
    pointHoverBorderColor: '#4fc3f7'
  },
  green: {
    backgroundColor: '#66bb6a',
    borderColor: '#81c784',
    pointBackgroundColor: '#66bb6a',
    pointBorderColor: '#81c784',
    pointHoverBackgroundColor: '#66bb6a',
    pointHoverBorderColor: '#81c784'
  },
  yellow: {
    backgroundColor: '#ffee58',
    borderColor: '#fff176',
    pointBackgroundColor: '#ffee58',
    pointBorderColor: '#fff176',
    pointHoverBackgroundColor: '#ffee58',
    pointHoverBorderColor: '#fff176'
  },
  orange: {
    backgroundColor: '#ff7043',
    borderColor: '#ff8a65',
    pointBackgroundColor: '#ff7043',
    pointBorderColor: '#ff8a65',
    pointHoverBackgroundColor: '#ff7043',
    pointHoverBorderColor: '#ff8a65'
  },
  grey: {
    backgroundColor: '#78909c',
    borderColor: '#90a4ae',
    pointBackgroundColor: '#78909c',
    pointBorderColor: '#90a4ae',
    pointHoverBackgroundColor: '#78909c',
    pointHoverBorderColor: '#90a4ae'
  },
  red: {
    backgroundColor: '#ef5350',
    borderColor: '#e57373',
    pointBackgroundColor: '#ef5350',
    pointBorderColor: '#e57373',
    pointHoverBackgroundColor: '#ef5350',
    pointHoverBorderColor: '#e57373'
  },
  purple: {
    backgroundColor: '#7e57c2',
    borderColor: '#9575cd',
    pointBackgroundColor: '#7e57c2',
    pointBorderColor: '#9575cd',
    pointHoverBackgroundColor: '#7e57c2',
    pointHoverBorderColor: '#9575cd'
  },
  blue_l: {
    backgroundColor: '#4fc3f7',
    borderColor: '#81d4fa',
    pointBackgroundColor: '#4fc3f7',
    pointBorderColor: '#81d4fa',
    pointHoverBackgroundColor: '#4fc3f7',
    pointHoverBorderColor: '#81d4fa'
  },
  green_l: {
    backgroundColor: '#81c784',
    borderColor: '#a5d6a7',
    pointBackgroundColor: '#81c784',
    pointBorderColor: '#a5d6a7',
    pointHoverBackgroundColor: '#81c784',
    pointHoverBorderColor: '#a5d6a7'
  },
  yellow_l: {
    backgroundColor: '#fff176',
    borderColor: '#fff59d',
    pointBackgroundColor: '#fff176',
    pointBorderColor: '#fff59d',
    pointHoverBackgroundColor: '#fff176',
    pointHoverBorderColor: '#fff59d'
  },
  orange_l: {
    backgroundColor: '#ff8a65',
    borderColor: '#ffab91',
    pointBackgroundColor: '#ff8a65',
    pointBorderColor: '#ffab91',
    pointHoverBackgroundColor: '#ff8a65',
    pointHoverBorderColor: '#ffab91'
  },
  grey_l: {
    backgroundColor: '#90a4ae',
    borderColor: '#b0bec5',
    pointBackgroundColor: '#90a4ae',
    pointBorderColor: '#b0bec5',
    pointHoverBackgroundColor: '#90a4ae',
    pointHoverBorderColor: '#b0bec5'
  },
  red_l: {
    backgroundColor: '#e57373',
    borderColor: '#ef9a9a',
    pointBackgroundColor: '#e57373',
    pointBorderColor: '#ef9a9a',
    pointHoverBackgroundColor: '#e57373',
    pointHoverBorderColor: '#ef9a9a'
  },
  purple_l: {
    backgroundColor: '#9575cd',
    borderColor: '#b39ddb',
    pointBackgroundColor: '#9575cd',
    pointBorderColor: '#b39ddb',
    pointHoverBackgroundColor: '#9575cd',
    pointHoverBorderColor: '#b39ddb'
  },

  colors: () => {
    return Object.keys(GraphStackBarColorSet).map(key => {
      if (key !== 'colors') {
        return GraphStackBarColorSet[key]
      }
    })
  }
}

export const GraphLineColorSets = GraphLineColorSet.colors()
export const GraphBarColorSets = GraphBarColorSet.colors()
export const GraphStackBarColorSets = GraphStackBarColorSet.colors()





// WEBPACK FOOTER //
// ./src/defines/chart-color.js